/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    addBtn: {
        tooltip: "Ajouter à la liste"
    },
    deleteBtn: {
        tooltip: "Supprimer l'élément"
    },
    emptyContainer: "Aucun élément"
};